import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import SearchExample from '../examples/Search';
import SearchInputsExample from '../examples/SearchInputs';
const SearchExampleSource = require('!!raw-loader!../examples/Search');
const SearchInputsExampleSource = require('!!raw-loader!../examples/SearchInputs');
export default class SearchPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Search"/>

                <h3>Search</h3>
                <p>
                    Only visual elements for assembled whispers are defined here. The functional part is directly in the
                    project in the react/search component
                </p>
                <div className="example bg-brand-dark p-7 mx-auto" style={{
                minHeight: '300px',
            }}>
                    <SearchExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{SearchExampleSource}</PrismCode>
                </pre>
                <h4>Properties</h4>
                <pre>
                    <PrismCode className="language-jsx">
                        {`
Search.Props = {|
  isFocused: boolean,
  isOpenable: boolean,
  children: Element<any>,
|};

Search.defaultProps = {
  isOpenable: true,
};

SearchInput.Props = {|
  placeholder: string,
  value: string,
  onChange: (value: string) => void,
  onToggle: (isFocused: boolean) => void,
  onKeyDown: (event: SyntheticKeyboardEvent<HTMLInputElement>) => void,
  isMobile: boolean,
|};

SearchResult.Props = {|
  isOpen: boolean,
  children: Element<any>,
|};

SearchResultList.Props = {|
  children: ChildrenArray<Element<typeof SearchResultItem>>,
|};

SearchResultItem.Props = {|
  isActive: boolean,
  href: string,
  title: string,
  subTitle?: string,
  rightColumn: Element<typeof Fragment> | string,
  highlightValue: string,
  onMouseDown: onMouseDownFunctionType,
  children: Element<any>,
|};
            `}
                    </PrismCode>
                </pre>

                <h3>Search Inputs</h3>
                <div className="example bg-brand-dark p-7 mx-auto">
                    <SearchInputsExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{SearchInputsExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
